import { StickyNote } from "lucide-react";
import type {
  ActionNodeReturnOrderNoteConfigDto,
  WorkflowV2NodeDto,
} from "@babackapp/private-api-client/types";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { ReturnOrderNoteActionNodeEditor } from "./editor";
import { ReturnOrderNoteActionNodePanel } from "./panel";

const newNodeDefaultValue = {
  actionType: "set_order_note",
  config: { note: "" } satisfies ActionNodeReturnOrderNoteConfigDto,
};

export default registerNode<ActionNodeReturnOrderNoteConfigDto>({
  type: "action:set_order_note",
  name: "workflowsEditor.nodes.setOrderNote.title",
  description: "workflowsEditor.nodes.setOrderNote.description",
  Icon: StickyNote,
  category: NodeCategory.ACTION,
  color: "blue",
  editor: {
    component: ReturnOrderNoteActionNodeEditor,
  },
  configPanel: {
    component: ReturnOrderNoteActionNodePanel,
  },
  // Extended action type outside the generated V2 union (return engine).
  newNodeDefaultData: newNodeDefaultValue as unknown as WorkflowV2NodeDto["data"],
});

export { ReturnOrderNoteActionNodeEditor } from "./editor";
export { ReturnOrderNoteActionNodePanel } from "./panel";
